import React from 'react';

import { P } from '../P/P';

import { Section } from './Section';
import { H2 } from './H2';
import { UL } from './UL';
import { LI } from './LI';

export const LE3 = () => (
  <Section>

    <P gapAfter>
      In der Lerneinheit 3 beschäftigen sich die SuS mit dem kritischen Trend der Fast Fashion. Sie lernen die Zusammenhänge und Auswirkungen von Herstellung und Entsorgung kennen und bewerten diese.
    </P>

    <P gapAfter>
      Definition:
      <br />
      &#8222;<b>Fast Fashion</b> bezeichnet ein Geschäftsmodell des Textilhandels, bei dem die Kollektion laufend geändert und die Zeit von den neuesten Designs der Modeschöpfer zur Massenware in den Filialen stark verkürzt wird.”
      <br />
      (Quelle: Wikipedia)
    </P>

    <H2>Unterrichtsimpulse:</H2>

    <UL>
      <LI>
        <P gapAfter>
          Werten Sie den Kleiderschrank-Check der SuS gemeinsam aus:
        </P>
        <UL disc>
          <LI>Auf wie viele Teile Oberbekleidung kommt die ganze Klasse? Was ist der Durchschnitt pro Person? Falls individuelle Aussagen hier vermieden werden sollen, geben Sie Angaben wie mehr/weniger als 50/100 Teile vor etc.</LI>
          <LI>Aus welchen Ländern kommt die meiste Kleidung? Erstellen Sie gemeinsam eine Statistik.</LI>
          <LI>Aus welchen Material besteht die Kleidung? Auch hierfür können Sie eine Statistik erstellen.</LI>
        </UL>
      </LI>

      <LI gapBefore>
        Bearbeiten Sie folgende Einschätzungsfragen entweder in Einzelarbeit auf dem
      </LI>
    </UL>

  </Section>
);



// WEBPACK FOOTER //
// ./src/components/LE/LE3.js